<template>
  <div id="organization">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>项目设置</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="organizationActive" @tab-click="handleClick">
        <!-- 项目类型 -->
        <el-tab-pane label="项目类型" name="1">
          <div class="searchRow">
            <el-button class="creat" style="background-color:#40A0F2;" @click="addUserClick">新建</el-button>
          </div>
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="tableData"
            stripe
            height="calc(100% - 68px - 20px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column
              prop="project_type_name"
              :show-overflow-tooltip="true"
              align="center"
              label="项目类型名称"
            ></el-table-column>
            <el-table-column
              prop="project_type_abbreviation"
              :show-overflow-tooltip="true"
              align="center"
              label="简拼"
            ></el-table-column>
            <el-table-column prop="address" width="300" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEditProject(scope.row)" class="tableBtn">编辑</el-button>
                <el-button
                  @click="handleRemoveUser(scope.row)"
                  class="tableBtn"
                  :disabled="isAdmin1==0 ? false : true"
                  style="border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 评价类型 -->
        <el-tab-pane label="评价类型" name="2">
          <div class="searchRow">
            <el-button class="creat" style="background-color:#40A0F2;" @click="addClassClick">新建</el-button>
          </div>
          <!-- <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="tableData2"
            stripe
            height="calc(100% - 68px - 20px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column
              prop="pte_name"
              :show-overflow-tooltip="true"
              align="center"
              label="评价类型名称"
            ></el-table-column>
            <el-table-column
              prop="pte_abbreviation"
              :show-overflow-tooltip="true"
              align="center"
              label="简拼"
            ></el-table-column>

            <el-table-column prop="address" width="400" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEditClass(scope.row)" class="tableBtn">编辑</el-button>
                <el-button
                  @click="handleRemoveClass(scope.row)"
                  :disabled="isAdmin2==0 ? false : true"
                  class="tableBtn"
                  style="border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>-->
          <div class="tableBox">
            <tree-table
              :is-fold="false"
              :show-overflow-tooltip="true"
              :data="tableData2"
              children-prop="children"
              :columns="columns"
              height="calc(100% - 68px - 20px - 800px)"
              :show-row-hover="false"
              :expand-type="false"
              :selection-type="false"
            >
              <template slot="pte_name" slot-scope="scope">
                <!-- <span v-if="scope.row.pte_name">{{scope.row.pte_name +'123'}}</span> -->
              </template>
              <template slot="pte_abbreviation" slot-scope="scope">
                <!-- <span v-if="scope.row.pte_name">{{scope.row.pte_name +'123'}}</span> -->
              </template>
              <template slot="edit" slot-scope="scope">
                <el-button @click="handleEditClass(scope.row)" class="tableBtn">编辑</el-button>
                <el-button
                  @click="handleRemoveClass(scope.row)"
                  :disabled="isAdmin2==0 ? false : true"
                  class="tableBtn"
                  style="border-color: #999999;color: #666666;"
                >删除</el-button>
              </template>
            </tree-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span
          class="title-name"
          v-if="showForm=='2-edit'"
          style="color:#128BF1;margin-right:5px"
        >张某某</span>-->
        <span class="title-age" v-if="showForm=='1'">新增项目类型</span>
        <span class="title-age" v-if="showForm=='1-edit'">编辑项目类型</span>
        <span class="title-age" v-if="showForm=='2'">新增评价类型</span>
        <span class="title-age" v-if="showForm=='2-edit'">编辑评价类型</span>
      </div>
      <div class="diaContainer">
        <!-- 编辑项目类型 -->
        <el-form ref="form" :model="editUserForm" label-width="30%" v-if="showForm=='1-edit'">
          <el-form-item label="项目类型">
            <el-input placeholder="请输入项目类型名称" v-model="editUserForm.project_type_name"></el-input>
          </el-form-item>
          <el-form-item label="简拼">
            <el-input placeholder="简拼" v-model="editUserForm.project_type_abbreviation"></el-input>
          </el-form-item>
        </el-form>
        <!-- 新增项目类型 -->
        <el-form ref="form" :model="addUserForm" label-width="30%" v-if="showForm=='1'">
          <el-form-item label="项目类型">
            <el-input placeholder="请输入项目类型名称" v-model="addUserForm.project_type_name"></el-input>
          </el-form-item>
          <el-form-item label="简拼">
            <el-input placeholder="简拼" v-model="addUserForm.project_type_abbreviation"></el-input>
          </el-form-item>
        </el-form>

        <!-- 新增评价类型表单 -->
        <el-form ref="form" :model="addClassForm" label-width="30%" v-if="showForm=='2'">
          <el-form-item label="评价类型">
            <el-input placeholder="请输入项目类型名称" v-model="addClassForm.pte_name"></el-input>
          </el-form-item>

          <el-form-item label="父级类型">
            <el-cascader
              :modal-append-to-body="false"
              @change="handleCasAddChange"
              class="modifyCascader"
              filterable
              clearable
              v-model="addClassForm.parent_id"
              :options="tableData2"
              :props="{ value:'pte_id', label:'pte_name', checkStrictly: true}"
              placeholder="请选父级类型"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="简称">
            <el-input placeholder="简称" v-model="addClassForm.pte_abbreviation"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input placeholder="排序" type="number" v-model="addClassForm.sort"></el-input>
          </el-form-item>
          <el-form-item label="结算类型">
            <el-select
              style="width:100%"
              v-model="addClassForm.settlement_type"
              filterable
              @change="handleSelectChangeSumType"
              placeholder="请选择结算类型"
            >
              <el-option
                style="max-width: 40vw;"
                v-for="item in sumTypeOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="addClassForm.settlement_type==1?'金额':'百分比'"
            v-if="addClassForm.settlement_type==1 || addClassForm.settlement_type==2"
          >
            <div class="withLabel">
              <el-input
                :placeholder="addClassForm.settlement_type==1?'请输入金额':'请输入百分比'"
                v-model="addClassForm.money"
              ></el-input>
              <div class="danwei" v-if="addClassForm.settlement_type==1">元</div>
              <div class="danwei" v-if="addClassForm.settlement_type==2">%</div>
            </div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input placeholder="备注" type="textarea" v-model="addClassForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <!-- 编辑评价类型表单 -->
        <el-form ref="form" label-width="30%" v-if="showForm=='2-edit'">
          <el-form-item label="评价类型">
            <el-input placeholder="请输入项目类型名称" v-model="editClassForm.pte_name"></el-input>
          </el-form-item>
          <el-form-item label="父级类型">
            <el-cascader
              :modal-append-to-body="false"
              @change="handleCasEditChange"
              class="modifyCascader"
              filterable
              clearable
              v-model="editClassForm.parent_id"
              :options="tableData2"
              :props="{ value:'pte_id', label:'pte_name', checkStrictly: true}"
              placeholder="请选父级类型"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="简拼">
            <el-input placeholder="简拼" v-model="editClassForm.pte_abbreviation"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input placeholder="排序" type="number" v-model="editClassForm.sort"></el-input>
          </el-form-item>
          <el-form-item label="结算类型">
            <el-select
              style="width:100%"
              v-model="editClassForm.settlement_type"
              filterable
              @change="handleSelectChangeSumType"
              placeholder="请选择结算类型"
            >
              <el-option
                style="max-width: 40vw;"
                v-for="item in sumTypeOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="editClassForm.settlement_type==1?'金额':'百分比'"
            v-if="editClassForm.settlement_type==1 || editClassForm.settlement_type==2"
          >
            <div class="withLabel">
              <el-input
                :placeholder="editClassForm.settlement_type==1?'请输入金额':'请输入百分比'"
                v-model="editClassForm.money"
              ></el-input>
              <div class="danwei" v-if="editClassForm.settlement_type==1">元</div>
              <div class="danwei" v-if="editClassForm.settlement_type==2">%</div>
            </div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input placeholder="备注" type="textarea" v-model="editClassForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="addFlag" @click="DiaClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addFlag: false,
      showForm: '',
      organizationActive: '1',
      searchInfo1: '',
      searchInfo2: '',
      searchInfo3: '',
      currentUserPage: 1,
      userPageSize: 10,

      currentPage1: 1,
      pageSize1: 10,
      total1: 0,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      currentPage3: 1,
      pageSize3: 10,
      total3: 0,
      sumTypeOptions: [
        {
          id: '1',
          label: '固定金额',
        },
        {
          id: '2',
          label: '合同百分比',
        },
        {
          id: '99',
          label: '特殊定义',
        },
      ],
      columns: [
        {
          label: '评价类型名称',
          type: 'template',
          template: 'name1',
          prop: 'pte_name',
          headerAlign: 'center',
          width: '350',
        },
        {
          label: '简拼',
          align: 'center',
          prop: 'pte_abbreviation',
          align: 'center',
          headerAlign: 'center',
          width: '150',
        },
        // {
        //   label: '抄送人',
        //   type: 'template',
        //   template: 'sendPeople',
        //   width: '425',
        // },
        {
          label: '操作',
          type: 'template',
          width: '150',
          align: 'center',
          headerAlign: 'center',
          template: 'edit',
        },
      ],
      tiemID: null,
      timeDou: 100,

      editClassName: '',
      editClassId: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      userTotal: 0,
      dialogVisible: false,
      // 新增成员
      addUserForm: {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
      },

      editUserId: '',
      // 新增评价类型表单
      addClassForm: {
        pte_name: '',
        pte_abbreviation: '',
        parent_id: '',
        settlement_type: '',
        money: '',
        remark: '',
        sort: '',
      },
      // 编辑评价类型
      editClassForm: {
        pte_name: '',
        pte_abbreviation: '',
        parent_id: '',
        settlement_type: '',
        money: '',
        remark: '',
        sort: '',
      },
      addUserForm: {
        project_type_name: '',
        project_type_abbreviation: '',
      },
      editUserForm: {
        project_type_name: '',
        project_type_abbreviation: '',
      },

      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
    }
  },
  methods: {
    handleSelectChangeSumType(val) {
      // this.addClassForm.settlement_type = ''
      // this.addClassForm.editClassForm = ''
      console.log('val', val)
      if (val == 99) {
        this.addClassForm.money = ''
        this.editClassForm.money = ''
      }
    },
    DiaClick() {
      if (this.showForm === '2') {
        // 新增部门
        this.addClassFormSubmit()
      } else if (this.showForm === '2-edit') {
        // 编辑部门
        this.editClassFormSubmit()
      } else if (this.showForm === '1-edit') {
        // 编辑成员
        this.editUserFormSubmit()
      } else if (this.showForm === '1') {
        // 编辑成员
        this.addUserFormSubmit()
      }
    },
    // *新增项目类型
    async addUserFormSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('project_type_name', this.addUserForm.project_type_name)
        param.append(
          'project_type_abbreviation',
          this.addUserForm.project_type_abbreviation
        )

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/project_type_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getProjectTypeList()
      }, this.timeDou)
    },
    // *编辑项目类型
    async editUserFormSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append4('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('project_type_id', this.editUserId)

        param.append('project_type_name', this.editUserForm.project_type_name)
        param.append(
          'project_type_abbreviation',
          this.editUserForm.project_type_abbreviation
        )

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/project_type_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getProjectTypeList()
      }, this.timeDou)
    },
    // *获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = res.datas.listInfo
      // :disabled="isAdmin1==0 ? false : true"
      this.isAdmin1 = res.datas.admin_state
      console.log('项目类型列表', this.tableData)
    },
    // *删除项目类型
    async handleRemoveUser(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('project_type_id', row.project_type_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/project_type_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectTypeList()
      }
    },
    // *点击编辑成员
    async handleEditProject(row) {
      this.showForm = '1-edit'
      this.editUserId = row.project_type_id
      this.editUserForm.project_type_name = row.project_type_name
      this.editUserForm.project_type_abbreviation =
        row.project_type_abbreviation

      console.log('编辑成员详情', this.editUserForm)
      this.dialogVisible = true
    },

    // *删除评价类型
    async handleRemoveClass(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('pte_id', row.pte_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/pte_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getClassList()
      }
    },

    // *点击编辑评价类型
    async handleEditClass(row) {
      this.showForm = '2-edit'
      this.editClassForm.pte_name = row.pte_name
      this.editClassForm.pte_abbreviation = row.pte_abbreviation

      this.editClassForm.parent_id = row.parent_id
      this.editClassForm.settlement_type = row.settlement_type
      this.editClassForm.money = row.money
      this.editClassForm.sort = row.sort
      this.editClassForm.remark = row.remark

      if (this.editClassForm.settlement_type == 0) {
        this.editClassForm.settlement_type = ''
      }
      this.editClassId = row.pte_id
      this.dialogVisible = true
    },
    // *编辑评价类型提交
    async editClassFormSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        if (!this.editClassForm.remark) {
          this.editClassForm.remark = ''
        }
        if (!this.editClassForm.pte_abbreviation) {
          this.editClassForm.pte_abbreviation = ''
        }
        if (!this.editClassForm.pte_name) {
          this.editClassForm.pte_name = ''
        }
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('pte_id', this.editClassId)

        param.append('pte_name', this.editClassForm.pte_name)
        param.append('pte_abbreviation', this.editClassForm.pte_abbreviation)

        param.append('parent_id', this.editClassForm.parent_id)
        param.append('settlement_type', this.editClassForm.settlement_type)
        param.append('money', this.editClassForm.money)
        param.append('sort', this.editClassForm.sort)
        param.append('remark', this.editClassForm.remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/pte_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getClassList()
      }, this.timeDou)
    },
    // *新增评价类型提交
    async addClassFormSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('pte_name', this.addClassForm.pte_name)
        param.append('pte_abbreviation', this.addClassForm.pte_abbreviation)

        param.append('parent_id', this.addClassForm.parent_id)
        param.append('settlement_type', this.addClassForm.settlement_type)
        param.append('money', this.addClassForm.money)
        param.append('sort', this.addClassForm.sort)
        param.append('remark', this.addClassForm.remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/pte_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.dialogVisible = false
        this.getClassList()
      }, this.timeDou)
    },
    // *获取评价类型列表
    async getClassList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        // url: '/api/Project/evaluation_type',
        url: '/api/Management/pte_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData2 = res.datas.listInfo
      this.total2 = parseInt(res.datas.count)
      // :disabled="isAdmin2==0 ? false : true"
      this.isAdmin2 = res.datas.admin_state
      console.log('评价类型列表', this.tableData2)
    },
    // 点击新增成员
    addUserClick() {
      this.showForm = '1'
      this.dialogVisible = true
    },

    // 点击新增部门
    addClassClick() {
      this.showForm = '2'
      this.dialogVisible = true
    },

    // 点击新增系统公告
    addMessageClick() {
      this.showForm = '3'
      this.dialogVisible = true
    },

    handleClick(tab, event) {
      console.log(tab, event)
    },
    handleUserSizeChange(val) {
      this.userPageSize = val
      this.getProjectTypeList()
    },
    handleUserCurrentChange(val) {
      this.currentUserPage = val
      this.getProjectTypeList()
    },
    handleSizeChange1(val) {
      this.pageSize1 = val
      this.currentPage1 = 1
      this.getProjectTypeList()
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val
      this.getProjectTypeList()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.currentPage2 = 1
      this.getClassList()
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
      this.getClassList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.addClassForm = {
        pte_name: '',
        pte_abbreviation: '',
        parent_id: '',
        settlement_type: '',
        money: '',
        remark: '',
        sort: '',
      }
      this.editClassForm = {
        pte_name: '',
        pte_abbreviation: '',
        parent_id: '',
        settlement_type: '',
        money: '',
        remark: '',
        sort: '',
      }

      this.addUserForm = {
        project_type_name: '',
        project_type_abbreviation: '',
      }
      this.editUserForm = {
        project_type_name: '',
        project_type_abbreviation: '',
      }

      this.editClassId = ''
      this.editUserId = ''
      this.addFlag = false
    },
    handleCasAddChange(val) {
      if (val.length > 0) {
        this.addClassForm.parent_id = val[val.length - 1]
      }
      console.log(this.addClassForm.parent_id)
    },
    handleCasEditChange(val) {
      console.log(val)

      if (val.length > 0) {
        this.editClassForm.parent_id = val[val.length - 1]
      }
      // console.log(this.editClassForm.parent_id)
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
    this.getProjectTypeList()
    this.getClassList()
  },
}
</script>
<style lang="less" scoped>
#organization {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    /deep/.tableSearch {
      width: 28%;
      // (deep)
      .el-input__inner {
        height: 48px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
      }
    }

    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: inherit;
      }
    }
    .el-input__inner {
      font-size: inherit;
      width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 90px;
        // font-size: 18px;
        resize: none;
        font-family: Microsoft YaHei !important;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 56px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 18px;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
}
// 修改表格样式
/deep/.zk-table {
  font-size: 16px;
}
/deep/.zk-table__body-row {
  height: 60px;
}
/deep/.zk-table__body-row:not(:first-of-type) {
  // border-top: none;
}
/deep/.zk-table__header-row {
  background-color: #40a0f2;
  line-height: 50px;
  font-size: 20px;
  color: #fff;
  .zk-table__header-cell {
    font-weight: normal;
  }
}
/deep/.zk-table--firstProp-header-inner {
  padding-left: 15px;
}
.addLast {
  cursor: pointer;
  margin-left: 10px;
}
.addLast:hover {
  color: #0099ff;
}
.overFlowInTable {
  display: block;
  width: 350px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.tableBox {
  height: calc(100% - 100px);
  margin-top: 20px;
  /deep/.zk-table {
    height: 100%;
    // overflow-y: auto;
  }
  /deep/.zk-table__body-wrapper {
    height: calc(100% - 65px) !important;
    overflow-y: auto !important;
  }
}

.modifyCascader {
  width: 80%;
  /deep/.el-input__inner {
    width: 100% !important;
  }
}
.withLabel {
  width: 100%;
  display: flex;
  .el-input {
    width: 80%;
    /deep/.el-input__inner {
      width: 100% !important;
    }
  }
  .danwei {
    margin-left: 20px;
  }
}
/deep/.zk-table--level-5-cell {
  overflow: hidden;
}
</style>